import React, { FC } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { EVENT_TIME_FIELDS } from 'services/constants';
import { useEvent } from 'components/context/EventContext';

import { EventTimeType } from 'types/enums';

import useStyles from './style';

const TimeInfo: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { event, isEventDj } = useEvent();

  return (
    <div className={classes.timeInfo}>
      {EVENT_TIME_FIELDS.map(field => {
        const time = event?.[field.key];

        return (!isEventDj && field.key === EventTimeType.arrivalTime ? (
          false
        ) : (
          true
        )) ? (
          <span
            className={classNames('timePreview', classes.timePreview)}
            data-hash={field.key}
            key={field.key}
          >
            <p>{t(field.translationKey)}:</p>
            <div
              className={classNames('time', {
                empty: !time,
              })}
            >
              {!!time ? time : t('addTime')}
            </div>
          </span>
        ) : null;
      })}
    </div>
  );
};

export default TimeInfo;
